import { fetchOnboarding } from "app/actions/onboarding";
import { gettingStartedLinks } from "app/components/GettingStarted/links";
import { useStoreActions } from "app/utils/hooks";
import { useCallback, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

const useGettingStartedModel = () => {
  const { onboarding } = useStoreActions({ onboarding: fetchOnboarding });
  const location = useLocation();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [isInspirationModalOpen, setIsInspirationModalOpen] = useState(false);

  const handleInspirationModal = () => {
    setIsInspirationModalOpen((prev) => !prev);
  };

  const handleTrialSuccessModal = useCallback(() => {
    setShowSuccessModal((prev) => !prev);
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("trial-success") === "true") {
      setShowSuccessModal(true);

      params.delete("trial-success");
      history.replace({
        search: params.toString(),
      });
    }
  }, [location.search, history]);

  const hyperLinkUrl = gettingStartedLinks;

  return {
    onboarding,
    isInspirationModalOpen,
    handleInspirationModal,
    hyperLinkUrl,
    showSuccessModal,
    handleTrialSuccessModal,
  };
};

export default useGettingStartedModel;
